<template>
	<div class="vcx-video vcx-col-12 vcx-col-10-lg vcx-col-offset-1-lg">
		<div class="vcx-video__background" :style="{ '--vcx-video-bg-opacity': bgOpacity }" />
		<video
			ref="video"
			crossorigin="Anonymous"
			webkit-playsinline="true"
			playsinline="true"
			:poster="appCloudfrontPath + '/images/marketing-site/vcx-thumbnail.webp'"
			loading="lazy"
			:controls="!showPlayButton"
		>
		</video>
		<BaseButton
			v-if="showPlayButton"
			:no-style="true"
			class="vcx-video__play-button vcx-flex vcx-items-center vcx-gap-100 vcx-label-lg vcx-no-wrap"
			data-test="play-button"
			@click="playVideo"
			><BaseSvgIcon name="video-play" width="24" height="24" /><span>Watch full video</span></BaseButton
		>
	</div>
</template>

<script setup lang="ts">
import { computed, ref, watch } from 'vue';
import { appCloudfrontPath } from '@constants';
import { useMediaControls } from '@vueuse/core';

const video = ref<HTMLVideoElement | null>(null);
const { playing, currentTime, ended } = useMediaControls(video, {
	src: `${appCloudfrontPath}/video/vcx-commercial-long.mp4`
});

const bgOpacity = computed(() => {
	if (showPlayButton.value) return 0.5;
	return 0;
});

const showPlayButton = computed(() => {
	return !playing.value && currentTime.value === 0;
});

watch(ended, (isEnded) => {
	if (isEnded) {
		video.value?.load(); // resets to poster
	}
});

async function playVideo() {
	if (video.value) {
		playing.value = true;
	}
}
</script>

<style scoped lang="scss">
@use '../../styles/vcx/responsive.scss' as *;
.vcx-video {
	position: relative;
	border-radius: var(--vcx-radius-100);

	video {
		border-radius: var(--vcx-radius-100);
		width: 100%;
	}

	&__play-button {
		position: absolute;
		bottom: 50%;
		left: 50%;
		transform: translate(-50%, 50%);
		opacity: 1;
		transition: opacity 0.3s ease;

		&:hover {
			opacity: 0.8;
		}

		@include vcx-media-md {
			bottom: 2rem;
			left: 50%;
			transform: translate(-50%, 0);
		}
	}

	&__background {
		border-radius: var(--vcx-radius-100);
		position: absolute;
		inset: 0;
		background-color: var(--vcx-bg-dark);
		opacity: var(--vcx-video-bg-opacity, 0.5);
		transition: opacity 0.3s ease;
		pointer-events: none;
	}
}
</style>
